<template>
    <transition name="share">
        <div v-show="ifShowShareBoard" class="share-wrap" @click="changeIfShowShareBoard(false)">
            <div class="share-nonweixin">
                <p v-if="!isWeixin">
                    点击浏览器下方的“
                    <i class="iconfont icon-caidan"></i>”分享给QQ好友
                </p>
                <p v-if="!isWeixin">
                    Safari浏览器点击“
                    <i class="iconfont icon-fenxiang"></i>”按钮
                </p>
            </div>
            <div v-if="isWeixin" class="share-weixin">点击右上角分享给好友哦～</div>
            <i v-if="isWeixin" class="iconfont icon-zhishi zhishi1"></i>
            <i v-if="!isWeixin" class="iconfont icon-zhishi zhishi2"></i>
        </div>
    </transition>
</template>

<script>
export default {
  props: {
    ifShowShareBoard: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isWeixin: true
    }
  },

  created () {
    const ua = navigator.userAgent.toLowerCase()
    this.isWeixin = ua.indexOf('micromessenger') !== -1
  },

  methods: {
    changeIfShowShareBoard (val) {
      this.$emit('update:ifShowShareBoard', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.share {
    &-wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.4);

        .zhishi1 {
            position: absolute;
            top: 72px;
            right: 64px;
            line-height: 132px;
            font-size: 132px;
            color: #ffffff;
            opacity: 0.75;
            transform: rotateX(180deg) rotateZ(90deg);
        }

        .zhishi2 {
            position: absolute;
            bottom: 144px;
            right: 154px;
            line-height: 132px;
            font-size: 132px;
            color: #ffffff;
            opacity: 0.75;
            transform: rotateX(180deg) rotateY(180deg) rotateZ(0deg);
        }

        .icon-fenxiang {
            font-size: 36px;
        }

        .icon-caidan {
            font-size: 28px;
        }
    }

    &-weixin {
        position: absolute;
        top: 172px;
        right: 236px;
        font-size: 32px;
        line-height: 45px;
        color: #ffffff;
    }

    &-nonweixin {
        position: absolute;
        bottom: 282px;
        left: 88px;
        right: 88px;
        line-height: 45px;
        text-align: center;
        font-size: 32px;
        color: #ffffff;
    }

    &-enter,
    &-leave-to {
        opacity: 0;
    }

    &-enter-to {
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/app/GenH5/transition/ShareTransition.vue